import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70040899"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "decoration"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "decoration-item" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "decoration"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "decoration-item2" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "popUp",
    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.emit('hide')), ["prevent","stop"]))
  }, [
    _createVNode(_Transition, { name: "popUp" }, {
      default: _withCtx(() => [
        _createElementVNode("nav", {
          ref: "navigation",
          class: _normalizeClass(["bottom-navigation", {'move-popup-visibe': !_ctx.isMediaSettingsPopUp}]),
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            onTouchstartPassive: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.elementDraged && _ctx.elementDraged(...args)), ["stop"])),
            onTouchmovePassive: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touchMove && _ctx.touchMove(...args)), ["stop"])),
            onTouchend: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.elementDroped && _ctx.elementDroped(...args)), ["stop"])),
            onMousedown: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.elementDraged && _ctx.elementDraged(...args)), ["stop"])),
            onMousemove: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args)), ["stop"])),
            onMouseup: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.elementDroped && _ctx.elementDroped(...args)), ["stop"]))
          }, [
            (!_ctx.hideTopDecoration)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", null, [
                _renderSlot(_ctx.$slots, "title", {}, undefined, true)
              ]),
              _renderSlot(_ctx.$slots, "top-right", {}, undefined, true)
            ])
          ], 32),
          _createElementVNode("div", {
            class: _normalizeClass(["body", {'pb-15': _ctx.hideBottomDecoration}])
          }, [
            _renderSlot(_ctx.$slots, "body", {}, undefined, true)
          ], 2),
          (!_ctx.hideBottomDecoration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 3
    })
  ]))
}